module.exports = __webpack_public_path__ + "aa5245a5e244041eefbaad08831025b4.png";